import { render, staticRenderFns } from "./ViewTitlepage.vue?vue&type=template&id=ee4fa130&scoped=true"
import script from "./ViewTitlepage.vue?vue&type=script&lang=js"
export * from "./ViewTitlepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4fa130",
  null
  
)

export default component.exports